<template>
    <v-container fluid>
        <v-layout>
            <v-flex>
                <h1 class="display-4 text-xs-center white--text">No posee los permisos necesarios</h1>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    export default {
        data() {
            return {
                mensaje: 'todo ok'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/errores/404.vue